import React from 'react';
import { Box, Stepper, Step, StepLabel, StepContent, Typography, Button } from '@mui/material';
import { useAppContext } from '../context/AppContext';
import { ConfigSetup } from './ConfigSetup';
import LayerSetup from './LayerSetup';
import ImageUpload from './ImageUpload';
import UniqueNFTUpload from './UniqueNFTUpload';
import GenerateCollection from './GenerateCollection';

const steps = [
  {
    label: 'Collection Configuration',
    description: 'Set up the basic parameters for your NFT collection.',
    component: <ConfigSetup />
  },
  {
    label: 'Layer Setup',
    description: 'Create layers for your NFT traits.',
    component: <LayerSetup />
  },
  {
    label: 'Image Upload',
    description: 'Upload images for each layer.',
    component: <ImageUpload />
  },
  {
    label: 'Unique NFTs (1/1)',
    description: 'Optional: Add unique one-of-one NFTs to your collection.',
    component: <UniqueNFTUpload />
  },
  {
    label: 'Collection Generation',
    description: 'Generate your unique NFT collection and download the results.',
    component: <GenerateCollection />
  }
];

const AppStepper: React.FC = () => {
  const { currentStep, setCurrentStep } = useAppContext();

  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleStepClick = (stepIndex: number) => {
    setCurrentStep(stepIndex);
  };

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: 2 }}>
      <Stepper activeStep={currentStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel>
              <Typography variant="h6">{step.label}</Typography>
            </StepLabel>
            <StepContent>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {step.description}
              </Typography>
              {step.component}
              
              {/* Only display Continue/Back buttons if not in step 0 (Configuration), 
                  step 1 (Layer Setup), step 2 (Image Upload) or step 3 (Unique NFTs) */}
              {index !== steps.length - 1 && index === currentStep && index !== 0 && index !== 1 && index !== 2 && index !== 3 && (
                <Box sx={{ mb: 2, mt: 1 }}>
                  <div>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Continue
                    </Button>
                    <Button
                      disabled={index === 0}
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Back
                    </Button>
                  </div>
                </Box>
              )}
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default AppStepper; 